export const FIXED_PER_UNIT_PRICE_ESTIMATOR_DEFAULT_CONTRACT_DURATION = 12;